export default __webpack_public_path__ + "static/media/cake.995f5f04.svg";